export default __webpack_public_path__ + "static/retreat_6-c3296302623a9c4d41d5fbf46060d0fb.jpg";